export const { API_URL } = process.env;
export const PROJECT_NAME = 'customform';

const uploadApiUrls = {
  development: 'https://ipa.elevio-staging.com',
  staging: 'https://ipa.elevio-staging.com',
  production: 'https://ipa.elev.io',
};

const origin = process.env.DEPLOY_ENV
  ? process.env.DEPLOY_ENV
  : process.env.NODE_ENV;

const IPA_URL = uploadApiUrls[origin];

export const RESOURCES = {
  getForm: {
    url: '${api_url}/${cuid}/addon/${id}', // eslint-disable-line no-template-curly-in-string
    method: 'GET',
  },
  postForm: {
    url: '${api_url}/${cuid}/customform/${id}', // eslint-disable-line no-template-curly-in-string
    method: 'POST',
  },
  getFilePassage: {
    url: `${IPA_URL}/data/filepassage/` + '${cuid}/anon', // eslint-disable-line no-useless-concat, no-template-curly-in-string
    method: 'GET',
  },
  putFile: {
    url: '${put_url}', // eslint-disable-line no-template-curly-in-string
    method: 'PUT',
    notJson: true,
    timeout: 120000,
  },
  getNonce: {
    url: `${IPA_URL}/api/nonce`, // eslint-disable-line no-template-curly-in-string
    method: 'GET',
  },
  suggestions: {
    url: IPA_URL + '/api/answer/${cuid}/${lan}/ticket?rows=3&url=${url}${auth}', // eslint-disable-line no-template-curly-in-string,no-useless-concat,prefer-template
    method: 'POST',
  },
};

export const defaultTexts = {
  multiSelect: 'Select one or more option...',
  singleSelect: 'Select an option...',
};



// WEBPACK FOOTER //
// ./src/config.js